import React, { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { TID } from "@/lib/testIds";

export default function StickyBuyBar({ onClick }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-40 transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
      aria-hidden={!show}
    >
      <div className="mx-auto max-w-3xl p-3 sm:p-4">
        <div className="glass flex items-center gap-3 rounded-2xl p-2.5 shadow-2xl">
          <div className="flex flex-col pl-2 leading-tight">
            <span className="text-[11px] uppercase tracking-widest text-neutral-400">Launch Price</span>
            <span className="font-display text-2xl text-white">
              ₹749 <span className="text-sm text-neutral-500 line-through">₹2000</span>
            </span>
          </div>
          <button
            data-testid={TID.stickyBuyBtn}
            onClick={onClick}
            className="ml-auto flex items-center gap-2 rounded-full bg-fire px-5 py-3 text-sm font-bold uppercase tracking-wider text-black animate-pulse-orange transition-transform hover:scale-[1.03] active:scale-[0.98]"
          >
            <ShoppingBag size={18} /> Buy Now
          </button>
        </div>
      </div>
    </div>
  );
}
